// /* eslint-disable jsx-a11y/click-events-have-key-events */
// /* eslint-disable jsx-a11y/no-static-element-interactions */
// /* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
// /* eslint-disable jsx-a11y/label-has-associated-control */
// /* eslint-disable jsx-a11y/interactive-supports-focus */
// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import { Url } from '../url/url';

// const statusColor = (remaining, alertVal) => {
//   if (remaining === 0)       return { bg: '#fee2e2', color: '#dc2626', label: 'Out of Stock' };
//   if (remaining <= alertVal) return { bg: '#fef9c3', color: '#ca8a04', label: 'Low Stock' };
//   return                            { bg: '#dcfce7', color: '#16a34a', label: 'In Stock' };
// };

// const TABS = ['All', 'Low Stock', 'Out of Stock'];

// const Field = ({ label, children }) => (
//   <div style={{ marginBottom: 14 }}>
//     <label style={{ display: 'block', fontWeight: 600, fontSize: 13, marginBottom: 6 }}>
//       {label}
//       {children}
//     </label>
//   </div>
// );

// const inputStyle = {
//   display: 'block',
//   width: '100%',
//   padding: '9px 12px',
//   borderRadius: 8,
//   border: '1px solid #e5e7eb',
//   marginTop: 6,
//   fontSize: 14,
//   boxSizing: 'border-box',
// };

// const Inventory = () => {
//   const [inventory, setInventory] = useState([]);
//   const [loading, setLoading]     = useState(true);
//   const [tab, setTab]             = useState('All');
//   const [search, setSearch]       = useState('');
//   const [selected, setSelected]   = useState(null);
//   const [modalType, setModalType] = useState('');
//   const [form, setForm]           = useState({ quantity: '', note: '', remaining: '', damaged: '', threshold: '' });
//   const [logs, setLogs]           = useState([]);
//   const [actionMsg, setActionMsg] = useState('');
//   const [syncing, setSyncing]     = useState(false);

//   const fetchInventory = async () => {
//     setLoading(true);
//     try {
//       const res = await axios.get(`${Url}/api/inventory`);
//       setInventory(res.data.data);
//     } catch (e) {
//       console.error(e);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => { fetchInventory(); }, []);

//   const handleSync = async () => {
//     setSyncing(true);
//     try {
//       const res = await axios.get(`${Url}/api/inventory/sync`);
//       setActionMsg(res.data.message);
//       fetchInventory();
//     } catch (e) {
//       setActionMsg('Sync failed');
//     } finally {
//       setSyncing(false);
//       setTimeout(() => setActionMsg(''), 3000);
//     }
//   };

//   const openModal = async (item, type) => {
//     setSelected(item);
//     setModalType(type);
//     setForm({
//       quantity:  '',
//       note:      '',
//       remaining: item.remainingProduct,
//       damaged:   item.damagedProduct,
//       threshold: item.lowStockAlert,
//     });
//     if (type === 'logs') {
//       try {
//         const res = await axios.get(`${Url}/api/inventory/${item.product._id}/logs`);
//         setLogs(res.data.data);
//       } catch (e) {
//         setLogs([]);
//       }
//     }
//   };

//   const closeModal = () => { setSelected(null); setModalType(''); setLogs([]); setActionMsg(''); };

//   const handleAction = async () => {
//     const pid = selected.product._id;
//     try {
//       if (modalType === 'restock') {
//         await axios.post(`${Url}/api/inventory/${pid}/restock`, { quantity: +form.quantity, note: form.note });
//       } else if (modalType === 'adjust') {
//         await axios.patch(`${Url}/api/inventory/${pid}/adjust`, { remaining: +form.remaining, damaged: +form.damaged, note: form.note });
//       } else if (modalType === 'return') {
//         await axios.post(`${Url}/api/inventory/${pid}/return`, { quantity: +form.quantity, note: form.note });
//       } else if (modalType === 'alert') {
//         await axios.patch(`${Url}/api/inventory/${pid}/low-stock-alert`, { threshold: +form.threshold });
//       }
//       setActionMsg('✓ Done!');
//       fetchInventory();
//       setTimeout(() => { setActionMsg(''); closeModal(); }, 1000);
//     } catch (e) {
//       setActionMsg(e.response?.data?.message || 'Error hua');
//     }
//   };

//   const filtered = inventory.filter(i => {
//     const s = statusColor(i.remainingProduct, i.lowStockAlert);
//     const matchTab =
//       tab === 'All'          ? true :
//       tab === 'Low Stock'    ? s.label === 'Low Stock' :
//       tab === 'Out of Stock' ? s.label === 'Out of Stock' : true;
//     const matchSearch =
//       i.product?.productName?.toLowerCase().includes(search.toLowerCase()) ||
//       i.product?.sku?.toLowerCase().includes(search.toLowerCase());
//     return matchTab && matchSearch;
//   });

//   const totalProducts  = inventory.length;
//   const outOfStock     = inventory.filter(i => i.remainingProduct === 0).length;
//   const lowStock       = inventory.filter(i => i.remainingProduct > 0 && i.remainingProduct <= i.lowStockAlert).length;
//   const totalRemaining = inventory.reduce((a, i) => a + i.remainingProduct, 0);

//   const logTypeColor = { restock: '#16a34a', sale: '#2563eb', adjustment: '#d97706', return: '#7c3aed' };

//   return (
//     <div style={{ padding: '24px', fontFamily: 'Inter, sans-serif' }}>

//       {/* Header */}
//       <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
//         <div>
//           <h4 style={{ margin: 0, fontWeight: 700 }}>📦 Inventory Management</h4>
//           <p style={{ margin: 0, color: '#6b7280', fontSize: 13 }}>Saare products ka stock track karo</p>
//         </div>
//         <button
//           onClick={handleSync}
//           disabled={syncing}
//           style={{ background: '#6366f1', color: '#fff', border: 'none', borderRadius: 8, padding: '8px 18px', fontWeight: 600, cursor: 'pointer' }}
//         >
//           {syncing ? 'Syncing...' : '🔄 Sync Products'}
//         </button>
//       </div>

//       {actionMsg && (
//         <div style={{ background: '#dcfce7', color: '#16a34a', padding: '10px 16px', borderRadius: 8, marginBottom: 16, fontWeight: 600 }}>
//           {actionMsg}
//         </div>
//       )}

//       {/* Stats Cards */}
//       <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16, marginBottom: 24 }}>
//         {[
//           { label: 'Total Products',  value: totalProducts,  bg: '#eff6ff', color: '#2563eb' },
//           { label: 'Total Remaining', value: totalRemaining, bg: '#f0fdf4', color: '#16a34a' },
//           { label: 'Low Stock',       value: lowStock,       bg: '#fefce8', color: '#ca8a04' },
//           { label: 'Out of Stock',    value: outOfStock,     bg: '#fff1f2', color: '#dc2626' },
//         ].map(c => (
//           <div key={c.label} style={{ background: c.bg, borderRadius: 12, padding: '16px 20px' }}>
//             <div style={{ color: c.color, fontWeight: 700, fontSize: 28 }}>{c.value}</div>
//             <div style={{ color: '#6b7280', fontSize: 13, marginTop: 4 }}>{c.label}</div>
//           </div>
//         ))}
//       </div>

//       {/* Search + Tabs */}
//       <div style={{ display: 'flex', gap: 12, marginBottom: 20, flexWrap: 'wrap' }}>
//         <input
//           placeholder="🔍 Product name ya SKU search karo..."
//           value={search}
//           onChange={e => setSearch(e.target.value)}
//           style={{ flex: 1, minWidth: 220, padding: '9px 14px', borderRadius: 8, border: '1px solid #e5e7eb', fontSize: 14 }}
//         />
//         <div style={{ display: 'flex', gap: 8 }}>
//           {TABS.map(t => (
//             <button key={t} onClick={() => setTab(t)}
//               style={{
//                 padding: '8px 16px', borderRadius: 8, border: 'none', fontWeight: 600, cursor: 'pointer', fontSize: 13,
//                 background: tab === t ? '#6366f1' : '#f3f4f6',
//                 color:      tab === t ? '#fff'    : '#374151',
//               }}
//             >{t}</button>
//           ))}
//         </div>
//       </div>

//       {/* Table */}
//       {loading ? (
//         <div style={{ textAlign: 'center', padding: 60 }}>
//           <div className="spinner-border text-primary" />
//         </div>
//       ) : (
//         <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #e5e7eb', overflow: 'auto' }}>
//           <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14 }}>
//             <thead>
//               <tr style={{ background: '#f9fafb', borderBottom: '1px solid #e5e7eb' }}>
//                 {['#', 'Product', 'SKU', 'Total', 'Remaining', 'Sold', 'Damaged', 'Returned', 'Status', 'Actions'].map(h => (
//                   <th key={h} style={{ padding: '12px 14px', textAlign: 'left', fontWeight: 600, color: '#374151', whiteSpace: 'nowrap' }}>{h}</th>
//                 ))}
//               </tr>
//             </thead>
//             <tbody>
//               {filtered.length === 0 ? (
//                 <tr>
//                   <td colSpan={10} style={{ textAlign: 'center', padding: 40, color: '#9ca3af' }}>Koi product nahi mila</td>
//                 </tr>
//               ) : filtered.map((item, idx) => {
//                 const s = statusColor(item.remainingProduct, item.lowStockAlert);
//                 return (
//                   <tr key={item._id} style={{ borderBottom: '1px solid #f3f4f6' }}>
//                     <td style={{ padding: '12px 14px', color: '#9ca3af' }}>{idx + 1}</td>
//                     <td style={{ padding: '12px 14px' }}>
//                       <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
//                         <img
//                           src={item.product?.thumbnailImage}
//                           alt={item.product?.productName || 'product'}
//                           style={{ width: 38, height: 38, borderRadius: 8, objectFit: 'cover' }}
//                         />
//                         <span style={{ fontWeight: 600, color: '#111827' }}>{item.product?.productName}</span>
//                       </div>
//                     </td>
//                     <td style={{ padding: '12px 14px', color: '#6b7280', fontFamily: 'monospace' }}>{item.product?.sku}</td>
//                     <td style={{ padding: '12px 14px', fontWeight: 600 }}>{item.totalProduct}</td>
//                     <td style={{ padding: '12px 14px', fontWeight: 700, color: s.color }}>{item.remainingProduct}</td>
//                     <td style={{ padding: '12px 14px' }}>{item.soldProduct}</td>
//                     <td style={{ padding: '12px 14px', color: '#dc2626' }}>{item.damagedProduct}</td>
//                     <td style={{ padding: '12px 14px', color: '#7c3aed' }}>{item.returnedProduct}</td>
//                     <td style={{ padding: '12px 14px' }}>
//                       <span style={{ background: s.bg, color: s.color, padding: '3px 10px', borderRadius: 20, fontSize: 12, fontWeight: 700 }}>
//                         {s.label}
//                       </span>
//                     </td>
//                     <td style={{ padding: '12px 14px' }}>
//                       <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
//                         {[
//                           { label: '+ Restock', type: 'restock', bg: '#dcfce7', color: '#16a34a' },
//                           { label: '✏ Adjust',  type: 'adjust',  bg: '#eff6ff', color: '#2563eb' },
//                           { label: '↩ Return',  type: 'return',  bg: '#f5f3ff', color: '#7c3aed' },
//                           { label: '🔔 Alert',  type: 'alert',   bg: '#fefce8', color: '#ca8a04' },
//                           { label: '📋 Logs',   type: 'logs',    bg: '#f3f4f6', color: '#374151' },
//                         ].map(btn => (
//                           <button key={btn.type} onClick={() => openModal(item, btn.type)}
//                             style={{
//                               background: btn.bg, color: btn.color, border: 'none',
//                               borderRadius: 6, padding: '4px 10px', fontSize: 12,
//                               fontWeight: 600, cursor: 'pointer',
//                             }}
//                           >{btn.label}</button>
//                         ))}
//                       </div>
//                     </td>
//                   </tr>
//                 );
//               })}
//             </tbody>
//           </table>
//         </div>
//       )}

//       {/* Modal */}
//       {selected && (
//         <div
//           role="button"
//           tabIndex={0}
//           onKeyDown={e => e.key === 'Escape' && closeModal()}
//           style={{
//             position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)',
//             zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center',
//           }}
//           onClick={closeModal}
//         >
//           <div
//             role="dialog"
//             aria-modal="true"
//             style={{
//               background: '#fff', borderRadius: 16, padding: 28,
//               width: '100%', maxWidth: 480, maxHeight: '80vh', overflowY: 'auto',
//               boxShadow: '0 20px 60px rgba(0,0,0,0.2)',
//             }}
//             onClick={e => e.stopPropagation()}
//           >
//             {/* Modal Header */}
//             <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 20 }}>
//               <h5 style={{ margin: 0, fontWeight: 700 }}>
//                 {{ restock: '📦 Restock', adjust: '✏️ Adjust', return: '↩️ Return', alert: '🔔 Low Stock Alert', logs: '📋 Activity Logs' }[modalType]}
//               </h5>
//               <button
//                 onClick={closeModal}
//                 style={{ background: 'none', border: 'none', fontSize: 20, cursor: 'pointer', color: '#6b7280' }}
//               >✕</button>
//             </div>

//             <p style={{ color: '#6b7280', fontSize: 13, marginBottom: 20 }}>
//               {selected.product?.productName} — SKU: {selected.product?.sku}
//             </p>

//             {/* Logs */}
//             {modalType === 'logs' && (
//               logs.length === 0
//                 ? <p style={{ color: '#9ca3af', textAlign: 'center' }}>Koi log nahi hai</p>
//                 : logs.map((log, i) => (
//                   <div key={i} style={{ borderLeft: `3px solid ${logTypeColor[log.type] || '#ccc'}`, paddingLeft: 12, marginBottom: 14 }}>
//                     <div style={{ fontWeight: 600, color: logTypeColor[log.type], textTransform: 'capitalize' }}>
//                       {log.type} — {log.quantity} units
//                     </div>
//                     <div style={{ color: '#6b7280', fontSize: 12 }}>{log.note}</div>
//                     <div style={{ color: '#9ca3af', fontSize: 11 }}>{new Date(log.createdAt).toLocaleString('en-IN')}</div>
//                   </div>
//                 ))
//             )}

//             {/* Restock / Return */}
//             {(modalType === 'restock' || modalType === 'return') && (
//               <>
//                 <Field label="Quantity">
//                   <input
//                     type="number"
//                     min={1}
//                     value={form.quantity}
//                     onChange={e => setForm(f => ({ ...f, quantity: e.target.value }))}
//                     style={inputStyle}
//                   />
//                 </Field>
//                 <Field label="Note">
//                   <input
//                     type="text"
//                     value={form.note}
//                     onChange={e => setForm(f => ({ ...f, note: e.target.value }))}
//                     placeholder="Optional note..."
//                     style={inputStyle}
//                   />
//                 </Field>
//               </>
//             )}

//             {/* Adjust */}
//             {modalType === 'adjust' && (
//               <>
//                 <Field label="Remaining Stock">
//                   <input
//                     type="number"
//                     min={0}
//                     value={form.remaining}
//                     onChange={e => setForm(f => ({ ...f, remaining: e.target.value }))}
//                     style={inputStyle}
//                   />
//                 </Field>
//                 <Field label="Damaged Units">
//                   <input
//                     type="number"
//                     min={0}
//                     value={form.damaged}
//                     onChange={e => setForm(f => ({ ...f, damaged: e.target.value }))}
//                     style={inputStyle}
//                   />
//                 </Field>
//                 <Field label="Note">
//                   <input
//                     type="text"
//                     value={form.note}
//                     onChange={e => setForm(f => ({ ...f, note: e.target.value }))}
//                     placeholder="Adjustment reason..."
//                     style={inputStyle}
//                   />
//                 </Field>
//               </>
//             )}

//             {/* Alert */}
//             {modalType === 'alert' && (
//               <Field label="Low Stock Threshold">
//                 <input
//                   type="number"
//                   min={1}
//                   value={form.threshold}
//                   onChange={e => setForm(f => ({ ...f, threshold: e.target.value }))}
//                   style={inputStyle}
//                 />
//               </Field>
//             )}

//             {actionMsg && (
//               <p style={{ color: '#16a34a', fontWeight: 600, marginBottom: 12 }}>{actionMsg}</p>
//             )}

//             {modalType !== 'logs' && (
//               <button
//                 onClick={handleAction}
//                 style={{
//                   width: '100%', background: '#6366f1', color: '#fff',
//                   border: 'none', borderRadius: 10, padding: '11px',
//                   fontWeight: 700, fontSize: 15, cursor: 'pointer',
//                 }}
//               >
//                 Confirm
//               </button>
//             )}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Inventory;















/* eslint-disable no-return-assign */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import InventoryIcon        from '@mui/icons-material/Inventory2Outlined';
import SyncIcon             from '@mui/icons-material/SyncOutlined';
import SearchIcon           from '@mui/icons-material/SearchOutlined';
import AddCircleIcon        from '@mui/icons-material/AddCircleOutline';
import TuneIcon             from '@mui/icons-material/TuneOutlined';
import UndoIcon             from '@mui/icons-material/UndoOutlined';
import NotificationsIcon    from '@mui/icons-material/NotificationsNoneOutlined';
import ListAltIcon          from '@mui/icons-material/ListAltOutlined';
import CloseIcon            from '@mui/icons-material/CloseOutlined';
import WarningAmberIcon     from '@mui/icons-material/WarningAmberOutlined';
import BlockIcon            from '@mui/icons-material/BlockOutlined';
import CheckCircleIcon      from '@mui/icons-material/CheckCircleOutline';
import AllInboxIcon         from '@mui/icons-material/AllInboxOutlined';
import CategoryIcon         from '@mui/icons-material/CategoryOutlined';
import LocalShippingIcon    from '@mui/icons-material/LocalShippingOutlined';
import AssignmentReturnIcon from '@mui/icons-material/AssignmentReturnOutlined';
import { Url } from '../url/url';

const statusConfig = (remaining, alertVal) => {
  if (remaining === 0)       return { bg: '#fee2e2', color: '#dc2626', label: 'Out of Stock', dot: '#dc2626', Icon: BlockIcon };
  if (remaining <= alertVal) return { bg: '#fef9c3', color: '#ca8a04', label: 'Low Stock',    dot: '#ca8a04', Icon: WarningAmberIcon };
  return                            { bg: '#dcfce7', color: '#16a34a', label: 'In Stock',     dot: '#16a34a', Icon: CheckCircleIcon };
};

const TABS = [
  { key: 'All',          label: 'All Products', Icon: AllInboxIcon },
  { key: 'Low Stock',    label: 'Low Stock',    Icon: WarningAmberIcon },
  { key: 'Out of Stock', label: 'Out of Stock', Icon: BlockIcon },
];

const MODAL_CFG = {
  restock: { title: 'Restock Product',   color: '#16a34a', Icon: AddCircleIcon },
  adjust:  { title: 'Adjust Inventory',  color: '#2563eb', Icon: TuneIcon },
  return:  { title: 'Return Stock',      color: '#7c3aed', Icon: AssignmentReturnIcon },
  alert:   { title: 'Low Stock Alert',   color: '#ca8a04', Icon: NotificationsIcon },
  logs:    { title: 'Activity Logs',     color: '#374151', Icon: ListAltIcon },
};

const LOG_CFG = {
  restock:    { color: '#16a34a', Icon: AddCircleIcon },
  sale:       { color: '#2563eb', Icon: LocalShippingIcon },
  adjustment: { color: '#d97706', Icon: TuneIcon },
  return:     { color: '#7c3aed', Icon: AssignmentReturnIcon },
};

const inputStyle = {
  display: 'block', width: '100%', padding: '10px 12px',
  borderRadius: 8, border: '1.5px solid #e5e7eb',
  marginTop: 6, fontSize: 14, boxSizing: 'border-box', outline: 'none',
};

const Field = ({ label, children }) => (
  <div style={{ marginBottom: 16 }}>
    <label style={{ display: 'block', fontWeight: 600, fontSize: 12, color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 4 }}>
      {label}
      {children}
    </label>
  </div>
);

const Inventory = () => {
  const [inventory, setInventory] = useState([]);
  const [loading, setLoading]     = useState(true);
  const [tab, setTab]             = useState('All');
  const [search, setSearch]       = useState('');
  const [catFilter, setCatFilter] = useState('');
  const [selected, setSelected]   = useState(null);
  const [modalType, setModalType] = useState('');
  const [form, setForm]           = useState({ quantity: '', note: '', remaining: '', damaged: '', threshold: '' });
  const [logs, setLogs]           = useState([]);
  const [actionMsg, setActionMsg] = useState('');
  const [actionErr, setActionErr] = useState(false);
  const [syncing, setSyncing]     = useState(false);

  const fetchInventory = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${Url}/api/inventory`);
      setInventory(res.data.data);
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  };

  useEffect(() => { fetchInventory(); }, []);

  const handleSync = async () => {
    setSyncing(true);
    try {
      const res = await axios.get(`${Url}/api/inventory/sync`);
      setActionMsg(res.data.message); setActionErr(false);
      fetchInventory();
    } catch { setActionMsg('Sync failed'); setActionErr(true); }
    finally { setSyncing(false); setTimeout(() => setActionMsg(''), 3000); }
  };

  const openModal = async (item, type) => {
    setSelected(item); setModalType(type); setActionMsg(''); setActionErr(false);
    setForm({ quantity: '', note: '', remaining: item.remainingProduct, damaged: item.damagedProduct, threshold: item.lowStockAlert });
    if (type === 'logs') {
      try {
        const res = await axios.get(`${Url}/api/inventory/${item.product._id}/logs`);
        setLogs(res.data.data);
      } catch { setLogs([]); }
    }
  };

  const closeModal = () => { setSelected(null); setModalType(''); setLogs([]); setActionMsg(''); };

  const handleAction = async () => {
    const pid = selected.product._id;
    try {
      if (modalType === 'restock')      await axios.post(`${Url}/api/inventory/${pid}/restock`,          { quantity: +form.quantity, note: form.note });
      else if (modalType === 'adjust')  await axios.patch(`${Url}/api/inventory/${pid}/adjust`,           { remaining: +form.remaining, damaged: +form.damaged, note: form.note });
      else if (modalType === 'return')  await axios.post(`${Url}/api/inventory/${pid}/return`,            { quantity: +form.quantity, note: form.note });
      else if (modalType === 'alert')   await axios.patch(`${Url}/api/inventory/${pid}/low-stock-alert`,  { threshold: +form.threshold });
      setActionMsg('Successfully updated!'); setActionErr(false);
      fetchInventory();
      setTimeout(() => { setActionMsg(''); closeModal(); }, 1200);
    } catch (e) { setActionMsg(e.response?.data?.message || 'Error'); setActionErr(true); }
  };

  const categories    = [...new Set(inventory.map(i => i.product?.category).filter(Boolean))];
  const totalProducts  = inventory.length;
  const outOfStock     = inventory.filter(i => i.remainingProduct === 0).length;
  const lowStockCount  = inventory.filter(i => i.remainingProduct > 0 && i.remainingProduct <= i.lowStockAlert).length;
  const totalRemaining = inventory.reduce((a, i) => a + i.remainingProduct, 0);

  const filtered = inventory.filter(i => {
    const s = statusConfig(i.remainingProduct, i.lowStockAlert);
    const matchTab    = tab === 'All' ? true : s.label === tab;
    const matchSearch = !search || i.product?.productName?.toLowerCase().includes(search.toLowerCase()) || i.product?.sku?.toLowerCase().includes(search.toLowerCase()) || i.product?.category?.toLowerCase().includes(search.toLowerCase());
    const matchCat    = !catFilter || i.product?.category === catFilter;
    return matchTab && matchSearch && matchCat;
  });

  const mt = selected ? MODAL_CFG[modalType] : null;

  const StatCard = ({ label, value, bg, color, border, Icon: Ic }) => (
    <div style={{ background: bg, borderRadius: 14, padding: '20px 24px', border: `1.5px solid ${border}` }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <div>
          <div style={{ color, fontWeight: 800, fontSize: 32, lineHeight: 1 }}>{value}</div>
          <div style={{ color: '#6b7280', fontSize: 13, marginTop: 6, fontWeight: 500 }}>{label}</div>
        </div>
        <div style={{ background: `${color}18`, borderRadius: 10, padding: 8 }}>
          <Ic style={{ color, fontSize: 26 }} />
        </div>
      </div>
    </div>
  );

  const ActionBtn = ({ label, type, item, bg, color, border, Icon: Ic }) => (
    <button type="button" onClick={() => openModal(item, type)}
      style={{ background: bg, color, border: `1px solid ${border}`, borderRadius: 7, padding: '5px 10px', fontSize: 12, fontWeight: 700, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 4 }}>
      <Ic style={{ fontSize: 14 }} /> {label}
    </button>
  );

  return (
    <div style={{ padding: '28px 32px', fontFamily: "'Inter', sans-serif", background: '#f8fafc', minHeight: '100vh' }}>

      {/* Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 28 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
          <div style={{ background: '#4f46e5', borderRadius: 12, padding: 10 }}>
            <InventoryIcon style={{ color: '#fff', fontSize: 28 }} />
          </div>
          <div>
            <h3 style={{ margin: 0, fontWeight: 800, fontSize: 24, color: '#111827' }}>Inventory Management</h3>
            <p style={{ margin: '3px 0 0', color: '#6b7280', fontSize: 13 }}>Saare products ka real-time stock track karo</p>
          </div>
        </div>
        <button type="button" onClick={handleSync} disabled={syncing}
          style={{ background: syncing ? '#a5b4fc' : '#4f46e5', color: '#fff', border: 'none', borderRadius: 10, padding: '10px 22px', fontWeight: 700, fontSize: 14, cursor: syncing ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', gap: 8, boxShadow: '0 4px 12px rgba(79,70,229,0.3)' }}>
          <SyncIcon style={{ fontSize: 18, animation: syncing ? 'spin 1s linear infinite' : 'none' }} />
          {syncing ? 'Syncing...' : 'Sync Products'}
        </button>
      </div>

      {actionMsg && (
        <div style={{ background: actionErr ? '#fee2e2' : '#dcfce7', color: actionErr ? '#dc2626' : '#16a34a', padding: '12px 18px', borderRadius: 10, marginBottom: 20, fontWeight: 600, fontSize: 14, border: `1px solid ${actionErr ? '#fca5a5' : '#86efac'}` }}>
          {actionMsg}
        </div>
      )}

      {/* Stats */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16, marginBottom: 28 }}>
        <StatCard label="Total Products"  value={totalProducts}  bg="#eff6ff" color="#1d4ed8" border="#bfdbfe" Icon={AllInboxIcon} />
        <StatCard label="Total Remaining" value={totalRemaining} bg="#f0fdf4" color="#15803d" border="#bbf7d0" Icon={CheckCircleIcon} />
        <StatCard label="Low Stock"       value={lowStockCount}  bg="#fefce8" color="#a16207" border="#fde68a" Icon={WarningAmberIcon} />
        <StatCard label="Out of Stock"    value={outOfStock}     bg="#fff1f2" color="#be123c" border="#fecdd3" Icon={BlockIcon} />
      </div>

      {/* Tabs */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 20 }}>
        {TABS.map(({ key, label, Icon: Ic }) => {
          const count = key === 'All' ? inventory.length : key === 'Low Stock' ? lowStockCount : outOfStock;
          const active = tab === key;
          return (
            <button type="button" key={key} onClick={() => setTab(key)}
              style={{ padding: '9px 18px', borderRadius: 10, border: active ? '2px solid #4f46e5' : '2px solid #e5e7eb', fontWeight: 600, cursor: 'pointer', fontSize: 13, display: 'flex', alignItems: 'center', gap: 7, background: active ? '#4f46e5' : '#fff', color: active ? '#fff' : '#374151', boxShadow: active ? '0 4px 12px rgba(79,70,229,0.25)' : 'none' }}>
              <Ic style={{ fontSize: 16 }} />
              {label}
              <span style={{ background: active ? 'rgba(255,255,255,0.25)' : '#f3f4f6', color: active ? '#fff' : '#6b7280', borderRadius: 20, padding: '1px 8px', fontSize: 12, fontWeight: 700 }}>{count}</span>
            </button>
          );
        })}
      </div>

      {/* Search + Filter */}
      <div style={{ display: 'flex', gap: 12, marginBottom: 16, flexWrap: 'wrap' }}>
        <div style={{ flex: 1, minWidth: 240, position: 'relative' }}>
          <SearchIcon style={{ position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)', color: '#9ca3af', fontSize: 20 }} />
          <input
            placeholder="Product name, SKU ya category search karo..."
            value={search}
            onChange={e => setSearch(e.target.value)}
            style={{ width: '100%', padding: '10px 14px 10px 40px', borderRadius: 10, border: '1.5px solid #e5e7eb', fontSize: 14, boxSizing: 'border-box', background: '#fff', outline: 'none' }}
          />
        </div>
        <div style={{ position: 'relative' }}>
          <CategoryIcon style={{ position: 'absolute', left: 10, top: '50%', transform: 'translateY(-50%)', color: '#9ca3af', fontSize: 18 }} />
          <select value={catFilter} onChange={e => setCatFilter(e.target.value)}
            style={{ padding: '10px 14px 10px 34px', borderRadius: 10, border: '1.5px solid #e5e7eb', fontSize: 14, background: '#fff', color: '#374151', cursor: 'pointer', fontWeight: 500 }}>
            <option value="">All Categories</option>
            {categories.map(c => <option key={c} value={c}>{c}</option>)}
          </select>
        </div>
        {(search || catFilter || tab !== 'All') && (
          <button type="button" onClick={() => { setSearch(''); setCatFilter(''); setTab('All'); }}
            style={{ padding: '10px 16px', borderRadius: 10, border: '1.5px solid #fca5a5', background: '#fff1f2', color: '#dc2626', fontWeight: 600, cursor: 'pointer', fontSize: 13, display: 'flex', alignItems: 'center', gap: 6 }}>
            <CloseIcon style={{ fontSize: 16 }} /> Clear
          </button>
        )}
      </div>

      <div style={{ marginBottom: 12, color: '#6b7280', fontSize: 13, fontWeight: 500, display: 'flex', alignItems: 'center', gap: 8 }}>
        {filtered.length} product{filtered.length !== 1 ? 's' : ''} found
        {catFilter && <span style={{ background: '#eff6ff', color: '#1d4ed8', padding: '2px 10px', borderRadius: 20, fontSize: 12, display: 'flex', alignItems: 'center', gap: 4 }}><CategoryIcon style={{ fontSize: 13 }} />{catFilter}</span>}
      </div>

      {/* Table */}
      {loading ? (
        <div style={{ textAlign: 'center', padding: 80, color: '#6b7280' }}>
          <div className="spinner-border text-primary" />
          <p style={{ marginTop: 16 }}>Loading inventory...</p>
        </div>
      ) : (
        <div style={{ background: '#fff', borderRadius: 14, border: '1.5px solid #e5e7eb', overflow: 'auto', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14 }}>
            <thead>
              <tr style={{ background: '#f9fafb', borderBottom: '1.5px solid #e5e7eb' }}>
                {['#', 'Product', 'Category', 'SKU', 'Total', 'Remaining', 'Sold', 'Damaged', 'Status', 'Actions'].map(h => (
                  <th key={h} style={{ padding: '13px 16px', textAlign: 'left', fontWeight: 700, color: '#374151', whiteSpace: 'nowrap', fontSize: 13 }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filtered.length === 0 ? (
                <tr>
                  <td colSpan={10} style={{ textAlign: 'center', padding: 60, color: '#9ca3af' }}>
                    <SearchIcon style={{ fontSize: 48, color: '#e5e7eb' }} />
                    <div style={{ fontWeight: 600, marginTop: 8 }}>Koi product nahi mila</div>
                    <div style={{ fontSize: 13, marginTop: 4 }}>Search ya filter change karo</div>
                  </td>
                </tr>
              ) : filtered.map((item, idx) => {
                const s   = statusConfig(item.remainingProduct, item.lowStockAlert);
                const pct = item.totalProduct > 0 ? Math.round((item.remainingProduct / item.totalProduct) * 100) : 0;
                return (
                  <tr key={item._id} style={{ borderBottom: '1px solid #f3f4f6' }}
                    onMouseEnter={e => { e.currentTarget.style.background = '#f9fafb'; }}
                    onMouseLeave={e => { e.currentTarget.style.background = '#fff'; }}>

                    <td style={{ padding: '14px 16px', color: '#9ca3af', fontWeight: 600 }}>{idx + 1}</td>

                    <td style={{ padding: '14px 16px' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                        <img src={item.product?.thumbnailImage} alt={item.product?.productName || 'product'}
                          style={{ width: 44, height: 44, borderRadius: 10, objectFit: 'cover', border: '1.5px solid #f3f4f6' }} />
                        <div>
                          <div style={{ fontWeight: 700, color: '#111827', fontSize: 14, maxWidth: 180 }}>{item.product?.productName}</div>
                          {item.product?.subCategory && <div style={{ color: '#9ca3af', fontSize: 12, marginTop: 2 }}>{item.product.subCategory}</div>}
                        </div>
                      </div>
                    </td>

                    <td style={{ padding: '14px 16px' }}>
                      <span style={{ background: '#eff6ff', color: '#1d4ed8', padding: '4px 10px', borderRadius: 20, fontSize: 12, fontWeight: 600, display: 'inline-flex', alignItems: 'center', gap: 4 }}>
                        <CategoryIcon style={{ fontSize: 13 }} />
                        {item.product?.category || '—'}
                      </span>
                    </td>

                    <td style={{ padding: '14px 16px', color: '#6b7280', fontFamily: 'monospace', fontSize: 13, fontWeight: 600 }}>{item.product?.sku || '—'}</td>
                    <td style={{ padding: '14px 16px', fontWeight: 700, color: '#374151' }}>{item.totalProduct}</td>

                    <td style={{ padding: '14px 16px' }}>
                      <div style={{ fontWeight: 800, color: s.color, fontSize: 16 }}>{item.remainingProduct}</div>
                      <div style={{ marginTop: 4, background: '#f3f4f6', borderRadius: 4, height: 5, width: 70 }}>
                        <div style={{ background: s.dot, borderRadius: 4, height: 5, width: `${Math.min(pct, 100)}%` }} />
                      </div>
                      <div style={{ color: '#9ca3af', fontSize: 11, marginTop: 2 }}>{pct}% left</div>
                    </td>

                    <td style={{ padding: '14px 16px', fontWeight: 600 }}>{item.soldProduct}</td>
                    <td style={{ padding: '14px 16px', color: item.damagedProduct > 0 ? '#dc2626' : '#9ca3af', fontWeight: 600 }}>{item.damagedProduct}</td>

                    <td style={{ padding: '14px 16px' }}>
                      <div style={{ display: 'inline-flex', alignItems: 'center', gap: 5, background: s.bg, color: s.color, padding: '5px 12px', borderRadius: 20 }}>
                        <s.Icon style={{ fontSize: 14 }} />
                        <span style={{ fontSize: 12, fontWeight: 700 }}>{s.label}</span>
                      </div>
                      {item.remainingProduct <= item.lowStockAlert && item.remainingProduct > 0 && (
                        <div style={{ color: '#ca8a04', fontSize: 11, marginTop: 3, display: 'flex', alignItems: 'center', gap: 3 }}>
                          <NotificationsIcon style={{ fontSize: 12 }} /> Alert: {item.lowStockAlert}
                        </div>
                      )}
                    </td>

                    <td style={{ padding: '14px 16px' }}>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
                        <div style={{ display: 'flex', gap: 5 }}>
                          <ActionBtn label="Restock" type="restock" item={item} bg="#f0fdf4" color="#16a34a" border="#bbf7d0" Icon={AddCircleIcon} />
                          <ActionBtn label="Adjust"  type="adjust"  item={item} bg="#eff6ff" color="#2563eb" border="#bfdbfe" Icon={TuneIcon} />
                        </div>
                        <div style={{ display: 'flex', gap: 5 }}>
                          <ActionBtn label="Return"  type="return"  item={item} bg="#f5f3ff" color="#7c3aed" border="#ddd6fe" Icon={UndoIcon} />
                          <ActionBtn label="Alert"   type="alert"   item={item} bg="#fefce8" color="#ca8a04" border="#fde68a" Icon={NotificationsIcon} />
                          <ActionBtn label="Logs"    type="logs"    item={item} bg="#f9fafb" color="#374151" border="#e5e7eb" Icon={ListAltIcon} />
                        </div>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

      {/* Modal */}
      {selected && mt && (
        <div role="button" tabIndex={0} onKeyDown={e => e.key === 'Escape' && closeModal()}
          style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}
          onClick={closeModal}>
          <div role="dialog" aria-modal="true"
            style={{ background: '#fff', borderRadius: 18, width: '100%', maxWidth: 500, maxHeight: '85vh', overflowY: 'auto', boxShadow: '0 24px 80px rgba(0,0,0,0.25)' }}
            onClick={e => e.stopPropagation()}>

            {/* Modal Header */}
            <div style={{ padding: '20px 24px 16px', borderBottom: '1.5px solid #f3f4f6', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <div style={{ width: 42, height: 42, borderRadius: 11, background: `${mt.color}18`, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <mt.Icon style={{ color: mt.color, fontSize: 22 }} />
                </div>
                <div>
                  <h5 style={{ margin: 0, fontWeight: 800, color: '#111827', fontSize: 17 }}>{mt.title}</h5>
                  <p style={{ margin: 0, color: '#6b7280', fontSize: 13 }}>{selected.product?.productName}</p>
                </div>
              </div>
              <button type="button" onClick={closeModal}
                style={{ background: '#f3f4f6', border: 'none', borderRadius: 8, width: 32, height: 32, cursor: 'pointer', color: '#6b7280', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <CloseIcon style={{ fontSize: 18 }} />
              </button>
            </div>

            {/* Product info strip */}
            <div style={{ padding: '14px 24px', background: '#f9fafb', borderBottom: '1px solid #f3f4f6', display: 'flex', gap: 24, flexWrap: 'wrap' }}>
              {[
                { label: 'Total',     value: selected.totalProduct,     color: '#374151' },
                { label: 'Remaining', value: selected.remainingProduct,  color: statusConfig(selected.remainingProduct, selected.lowStockAlert).color },
                { label: 'Sold',      value: selected.soldProduct,       color: '#2563eb' },
                { label: 'Damaged',   value: selected.damagedProduct,    color: '#dc2626' },
              ].map(s => (
                <div key={s.label} style={{ textAlign: 'center' }}>
                  <div style={{ fontWeight: 800, color: s.color, fontSize: 20 }}>{s.value}</div>
                  <div style={{ color: '#9ca3af', fontSize: 11, marginTop: 2 }}>{s.label}</div>
                </div>
              ))}
              <div style={{ marginLeft: 'auto', textAlign: 'right' }}>
                <span style={{ background: '#f1f5f9', color: '#475569', padding: '3px 10px', borderRadius: 20, fontSize: 12, fontWeight: 600, fontFamily: 'monospace' }}>
                  SKU: {selected.product?.sku}
                </span>
                <div style={{ color: '#6b7280', fontSize: 11, marginTop: 4, display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 3 }}>
                  <CategoryIcon style={{ fontSize: 13 }} />
                  {selected.product?.category}
                </div>
              </div>
            </div>

            <div style={{ padding: '20px 24px' }}>

              {/* Logs */}
              {modalType === 'logs' && (
                logs.length === 0
                  ? <div style={{ textAlign: 'center', padding: '40px 0', color: '#9ca3af' }}>
                      <ListAltIcon style={{ fontSize: 48, color: '#e5e7eb' }} />
                      <div style={{ fontWeight: 600, marginTop: 8 }}>Koi activity log nahi hai</div>
                    </div>
                  : logs.map((log, i) => {
                      const lc = LOG_CFG[log.type] || { color: '#6b7280', Icon: ListAltIcon };
                      return (
                        <div key={i} style={{ display: 'flex', gap: 12, marginBottom: 12, padding: '12px 14px', background: '#f9fafb', borderRadius: 10, border: `1.5px solid ${lc.color}22` }}>
                          <div style={{ width: 36, height: 36, borderRadius: 9, background: `${lc.color}15`, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                            <lc.Icon style={{ color: lc.color, fontSize: 20 }} />
                          </div>
                          <div style={{ flex: 1 }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                              <span style={{ fontWeight: 700, color: lc.color, textTransform: 'capitalize', fontSize: 14 }}>{log.type}</span>
                              <span style={{ background: `${lc.color}18`, color: lc.color, padding: '2px 9px', borderRadius: 20, fontSize: 13, fontWeight: 700 }}>
                                {log.quantity} units
                              </span>
                            </div>
                            {log.note && <div style={{ color: '#6b7280', fontSize: 13, marginTop: 3 }}>{log.note}</div>}
                            <div style={{ color: '#9ca3af', fontSize: 11, marginTop: 4 }}>{new Date(log.createdAt).toLocaleString('en-IN')}</div>
                          </div>
                        </div>
                      );
                    })
              )}

              {/* Restock / Return */}
              {(modalType === 'restock' || modalType === 'return') && (<>
                <Field label="Quantity">
                  <input type="number" min={1} value={form.quantity} onChange={e => setForm(f => ({ ...f, quantity: e.target.value }))} placeholder="Enter quantity..." style={inputStyle} />
                </Field>
                <Field label="Note (optional)">
                  <input type="text" value={form.note} onChange={e => setForm(f => ({ ...f, note: e.target.value }))} placeholder="e.g. New batch received..." style={inputStyle} />
                </Field>
              </>)}

              {/* Adjust */}
              {modalType === 'adjust' && (<>
                <Field label="Set Remaining Stock">
                  <input type="number" min={0} value={form.remaining} onChange={e => setForm(f => ({ ...f, remaining: e.target.value }))} style={inputStyle} />
                </Field>
                <Field label="Damaged Units">
                  <input type="number" min={0} value={form.damaged} onChange={e => setForm(f => ({ ...f, damaged: e.target.value }))} style={inputStyle} />
                </Field>
                <Field label="Reason">
                  <input type="text" value={form.note} onChange={e => setForm(f => ({ ...f, note: e.target.value }))} placeholder="e.g. Physical stock count..." style={inputStyle} />
                </Field>
              </>)}

              {/* Alert */}
              {modalType === 'alert' && (<>
                <div style={{ background: '#fefce8', border: '1.5px solid #fde68a', borderRadius: 10, padding: '12px 14px', marginBottom: 16, fontSize: 13, color: '#92400e', display: 'flex', gap: 8 }}>
                  <WarningAmberIcon style={{ color: '#ca8a04', fontSize: 20, flexShrink: 0 }} />
                  Jab remaining stock is number se kam ya barabar ho, tab Low Stock alert show hoga.
                </div>
                <Field label="Low Stock Threshold (units)">
                  <input type="number" min={1} value={form.threshold} onChange={e => setForm(f => ({ ...f, threshold: e.target.value }))} style={inputStyle} />
                </Field>
              </>)}

              {actionMsg && (
                <div style={{ background: actionErr ? '#fee2e2' : '#dcfce7', color: actionErr ? '#dc2626' : '#16a34a', padding: '10px 14px', borderRadius: 8, marginBottom: 16, fontWeight: 600, fontSize: 14 }}>
                  {actionMsg}
                </div>
              )}

              {modalType !== 'logs' && (
                <button type="button" onClick={handleAction}
                  style={{ width: '100%', background: mt.color, color: '#fff', border: 'none', borderRadius: 11, padding: '13px', fontWeight: 800, fontSize: 15, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, boxShadow: `0 4px 14px ${mt.color}40` }}>
                  <mt.Icon style={{ fontSize: 20 }} />
                  Confirm {mt.title}
                </button>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Inventory;